const en = {
  translation: {
    language: 'English',
    reset: 'Reset',
    click_one: '{{count}} click',
    click_other: '{{count}} clicks',
  },
};

export default en;
